module.exports = __webpack_public_path__ + "img/bumble_03.c18f4ba4.png";